import { PublicAccessComputerDiagnosticsSectionDto } from '../types/models.types';
import { DiagnosticErrorItem } from '@/components/DiagnosticError/DiagnosticError.types';

export interface MappedComputerDiagnosticsSection {
  hasErrors: boolean;
  readStatus: string | null;
  expertSummary: string | null;
  errors: DiagnosticErrorItem[];
  /** Czy udało się nawiązać komunikację z pojazdem (na podstawie readStatus) */
  isCommunicationSuccessful: boolean;
}

export const mapComputerDiagnosticsSectionToUI = (
  section: PublicAccessComputerDiagnosticsSectionDto | null | undefined,
): MappedComputerDiagnosticsSection | null => {
  if (!section) {
    return null;
  }

  // Map API errors to UI format
  const mappedErrors: DiagnosticErrorItem[] = (section.errors || []).map((error) => ({
    errorCode: error.errorCode || '',
    description: error.errorDescription || 'Brak opisu',
  }));

  return {
    hasErrors: section.hasErrors || false,
    readStatus: section.readStatus || null,
    expertSummary: section.expertSummary || null,
    errors: mappedErrors,
    isCommunicationSuccessful: section.readStatus === 'READ',
  };
};
